<template>
  <div>
    <router-view> </router-view>
    <SupportPushPopup />
  </div>
</template>

<script>
import SupportPushPopup from "@/components/support/SupportPushPopup.vue";

export default {
  components: { SupportPushPopup },
};
</script>
